import { Box, Container, Typography } from "@mui/material";
import { TypeAnimation } from "react-type-animation";
import { keyframes } from "@mui/system";

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

const Shape = ({ delay = 0, ...props }) => (
  <Box
    sx={{
      position: "absolute",
      width: "150px",
      height: "150px",
      border: "2px solid",
      borderColor: "primary.main",
      animation: `${float} 6s ease-in-out infinite`,
      animationDelay: `${delay}s`,
      opacity: 0.5,
      ...props.sx
    }}
  />
);

function Hero() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Shape
        sx={{
          right: "10%",
          top: "20%",
          borderRadius: "50%",
          display: { xs: "none", md: "block" }
        }}
      />
      <Shape
        delay={1}
        sx={{
          left: "5%",
          bottom: "20%",
          transform: "rotate(45deg)",
          display: { xs: "none", md: "block" }
        }}
      />
      <Shape
        delay={2}
        sx={{
          right: "20%",
          bottom: "10%",
          borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
          display: { xs: "none", md: "block" }
        }}
      />

      <Container maxWidth="lg">
        <Box sx={{ maxWidth: "800px" }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", md: "4rem" },
              fontWeight: 800,
              mb: 2,
            }}
          >
            Hi, I'm{" "}
            <Box
              component="span"
              sx={{
                color: "primary.main",
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "2px",
                  bottom: "-4px",
                  left: 0,
                  backgroundColor: "primary.main",
                }
              }}
            >
              Oluwakemi Akindele
            </Box>
          </Typography>

          <Box sx={{ height: "80px", mb: 4 }}>
            <TypeAnimation
              sequence={[
                "Frontend Engineer",
                2000,
                "Innovative Developer",
                2000,
                "Agile Collaborator",
                2000,
              ]}
              wrapper="span"
              speed={50}
              repeat={Infinity}
              style={{
                fontSize: "2rem",
                display: "inline-block",
                color: "#FFC107",
              }}
            />
          </Box>

          <Typography
            variant="h6"
            sx={{
              color: "text.secondary",
              maxWidth: "600px",
              lineHeight: 1.8,
              mb: 4,
            }}
          >
            Passionate about building innovative and scalable solutions. I thrive on solving complex problems with clean, efficient, and high-quality code.

          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Hero;